import Frame1826 from "../../../assets/Frame1826";
import "./noResultFound.css";

const NoResultFound = () => {
  return (
    <div className="no-result-found">
      {/* <Frame1826 /> */}
      <object
        type="image/svg+xml"
        data="https://dlvkyia8i4zmz.cloudfront.net/i5lqUWynQc2gAe0r4Rqu_No_bot_found.svg"
      >
        <img
          src="https://dlvkyia8i4zmz.cloudfront.net/i5lqUWynQc2gAe0r4Rqu_No_bot_found.svg"
          alt="no_bots"
        />
      </object>
      <div className="suggestions">
        <h3>No bots found</h3>
        <ul>
          <li>Make sure that the name of the bot is spelled correctly</li>
          <li>Try using a different search criteria</li>
        </ul>
      </div>
    </div>
  );
};

export default NoResultFound;
